import { useState } from "react";
import { motion } from "framer-motion";
import { Sparkles, X } from "lucide-react";

export const EventBanner = () => {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.5 }}
      className="relative z-40 border-b border-gold/30 bg-[#0a0a0a]/70 px-6 py-3 backdrop-blur-xl"
      data-testid="event-banner"
    >
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-4 gap-y-1 text-center">
        <Sparkles className="h-4 w-4 shrink-0 text-gold" />
        <p className="text-[11px] font-semibold uppercase tracking-[0.25em] text-white sm:text-xs">
          <span className="text-gold">Samedi 14 novembre</span>
          <span className="mx-2 text-white/30">·</span>
          Soirée VIP — Factory58, Bobigny
          <span className="mx-2 hidden text-white/30 sm:inline">·</span>
          <span className="hidden sm:inline text-white/60">jusqu'à 5h du matin</span>
        </p>
        <a
          href="/soiree-vip"
          data-testid="event-banner-cta"
          className="rounded-full bg-gold px-5 py-1.5 text-[10px] font-bold uppercase tracking-[0.2em] text-[#0a0a0a] transition-transform duration-300 hover:scale-105"
        >
          Réserver
        </a>
        <button
          type="button"
          onClick={() => setVisible(false)}
          aria-label="Fermer l'annonce"
          data-testid="event-banner-close"
          className="absolute right-4 top-1/2 -translate-y-1/2 text-white/40 transition-colors hover:text-gold"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </motion.div>
  );
};
